
<section class="login-wrapper container-fluid">
  <form [formGroup]="signupFormGroup">
      <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-4  order-lg-1 order-2 login-content">
              <span class="backtopage mb-4 d-inline-block" (click)="backToLogin()">
                  <img [src]="environment1 + 'images/new-images/left-arrow.svg'" alt="left-arrow" loading="lazy">
              </span>
              <h1 *ngIf="!isTataOk">Create Account</h1>
              <div class="row">
                <div class="col-12 mb-4">
                  <label class="form-label mend">Account type</label>
                  <div class="d-flex gap-5">
                    <div *ngFor="let type of panTypeOptions; let i = index" class="form-check">
                      <input 
                        type="radio" 
                        class="form-check-input" 
                        [ngClass]="{ 'is-invalid': isSubmitted && f['panType']?.errors }"
                        name="panType" 
                        [value]="type.value"
                        formControlName="panType"
                        (change)="updateFirstNameValidation(type.value)"
                        [id]="'panType' + i"
                      />
                      <label class="form-check-label" [for]="'panType' + i">
                        {{ type.label | titlecase }}
                      </label>
                    </div>
                  </div>
                
                  <div *ngIf="isSubmitted && signupFormGroup.get('panType')?.errors"  class="error-message alert-danger">
                    <b *ngIf="signupFormGroup.get('panType')?.errors?.['required']"> &nbsp; Account type is required</b>
                  </div>
                </div>
                
                  <div class="col-12 mb-4" *ngIf="signupFormGroup.get('panType')?.value === 'Company'">
                      <label class="form-label mend">Company Name</label>
                      <input
                      formControlName="CompanyName"
                      [ngClass]="{ 'is-invalid': isSubmitted && f['CompanyName'].errors }"
                      type="text"
                      class="form-control h-48"
                      placeholder="Ex. xyz pvt ltd"
                      (input)="validateCompanyName($event)"
                      (blur)="checkCompanyNameError()"
                      maxlength="50"
                      >

                      <div *ngIf="companyNameError" class="error-message alert-danger">
                        <b>Company Name cannot contain ( &lt;, &gt;, &#123;, &#125;, &#124;, &#126;, &#94;, &#42; )</b>
                        Please input correct details.
                      </div>
                      <div
                        *ngIf="isSubmitted && f['CompanyName'].errors && signupFormGroup.get('CompanyName').invalid && (signupFormGroup.get('CompanyName').dirty || signupFormGroup.get('CompanyName').touched || isSubmitted)"
                        class="alert-danger">
                        <div class="error-message" *ngIf="signupFormGroup.get('CompanyName').errors?.['required']">
                          <b> &nbsp; Company name required</b>
                        </div>
                        <div class="error-message" *ngIf="signupFormGroup.get('CompanyName').errors?.['pattern']">
                          <b> &nbsp; Company name invalid</b>
                        </div>
                      </div>
                      <!-- <div class="error-message" *ngIf="hasError('CompanyName', 'invalidIndividualName')">
                        <b>Full Name cannot contain special characters </b>
                      </div> -->
                        <div class="error-message" *ngIf="hasError('CompanyName', 'invalidCompanyName')">
                        <b>Company Name cannot contain &lt; &gt; &#123; &#125; &#124; &#126; &#94; &#42;</b>
                      </div>
                  </div>
                  <div class="col-6 mb-4" *ngIf="signupFormGroup.get('panType')?.value === 'Individual'">
                      <label class="form-label mend">First Name</label>
                      <input
                      formControlName="firstName"
                      [ngClass]="{ 'is-invalid': isSubmitted && f['firstName'].errors }"
                      type="text"
                      class="form-control h-48"
                      placeholder="Ex. Pratik"
                      (keydown)="notAllowSpace($event)"
                      (input)="validateName($event, 'firstName')"
                      (blur)="checkNameError('firstName')"
                      maxlength="45"
                      >
                      <div *ngIf="nameErrors.firstName" class="error-message alert-danger">
                        <b>First Name cannot contain special characters (&period; &quot; &commat; &num; &dollar; and others)</b>

                      </div>
                      <!-- <div class="error-message" *ngIf="hasRequiredError('firstName')">
                          <b> &nbsp; *Required</b>
                      </div>
                      <div class="error-message" *ngIf="hasPatternError('firstName')">
                          <b> &nbsp; *Invalid</b>
                      </div> -->
                      <div
                        *ngIf="isSubmitted && f['firstName'].errors && signupFormGroup.get('firstName').invalid && (signupFormGroup.get('firstName').dirty || signupFormGroup.get('firstName').touched || isSubmitted)"
                        class="alert-danger">
                        <div class="error-message" *ngIf="signupFormGroup.get('firstName').errors?.['required']">
                          <b> &nbsp; First name required</b>
                        </div>
                        <div class="error-message" *ngIf="signupFormGroup.get('firstName').errors?.['pattern']">
                          <b> &nbsp; First name invalid</b>
                        </div>
                      </div>
                      <div class="error-message" *ngIf="hasError('firstName', 'invalidIndividualName')">
                        <b>First Name cannot contain special characters </b>
                      </div>
                        <!-- <div class="error-message" *ngIf="hasError('firstName', 'invalidCompanyName')">
                        <b>First Name cannot contain &lt; &gt; &#123; &#125; &#124; &#126; &#94; &#42;</b>
                      </div> -->
                  </div>

                  <div class="col-6 mb-4" *ngIf="signupFormGroup.get('panType')?.value === 'Individual'">
                      <!-- [ngClass]="{ 'is-invalid': isSubmitted && f['lastName'].errors }" -->
                      <label class="form-label ">Last Name</label>
                      <input formControlName="lastName" type="text" class="form-control h-48"
                          placeholder="Ex. Maurya" 
                          (keydown)="notAllowSpace($event)"  maxlength="45"
                          (input)="validateName($event, 'lastName')"
                          (blur)="checkNameError('lastName')"

                          >


                      <div class="error-message" *ngIf="hasRequiredError('lastName')">
                          <b> &nbsp; *Required</b>
                      </div>
                      <div *ngIf="nameErrors.lastName" class="error-message alert-danger">
                        <b>Last Name cannot contain special characters (&period; &quot; &commat; &num; &dollar; and others)</b>

                      </div>
                      <div class="error-message" *ngIf="hasError('lastName', 'invalidIndividualName')">
                        <b>Last Name cannot contain special characters </b>
                      </div>
                        <div class="error-message" *ngIf="hasError('lastName', 'invalidCompanyName')">
                        <b>Last Name cannot contain &lt; &gt; &#123; &#125; &#124; &#126; &#94; &#42;</b>
                      </div>
                      <!-- <div class="error-message" *ngIf="hasPatternError('lastName')">
                          <b> &nbsp; Last name is invalid</b>
                      </div> -->
                  </div>
                  <!-- <div class="col-12 mb-4">
                      <label class="form-label">Occupation</label>
                      <input formControlName="occupation" type="text" class="form-control h-48"
                      (keydown)="notAllowSpace($event)"
                          placeholder="Ex. Engineer">
                  </div> -->

                  <div class="col-6 mb-4" *ngIf="!signupFormGroup.get('panType')?.value">
                    <label class="form-label mend">First Name</label>
                    <input
                        formControlName="firstName"
                        [ngClass]="{ 'is-invalid': isSubmitted && f['firstName'].errors }"
                        type="text"
                        class="form-control h-48"
                        placeholder="Ex. Pratik"
                        (keydown)="notAllowSpace($event)"
                        (input)="validateName($event, 'firstName')"
                        (blur)="checkNameError('firstName')"
                        maxlength="45"
                    >
                    <div *ngIf="nameErrors.firstName" class="error-message alert-danger">
                      <b>First Name cannot contain special characters (&period; &quot; &commat; &num; &dollar; and others)</b>

                    </div>
                    <div *ngIf="isSubmitted && signupFormGroup.get('firstName')?.invalid" class="alert-danger">
                      <div class="error-message" *ngIf="signupFormGroup.get('firstName').errors?.['required']">
                        <b> &nbsp; First name required</b>
                      </div>
                      <div class="error-message" *ngIf="signupFormGroup.get('firstName').errors?.['pattern']">
                        <b> &nbsp; First name invalid</b>
                      </div>
                    </div>
                </div>
                
                <div class="col-6 mb-4" *ngIf="!signupFormGroup.get('panType')?.value">
                    <label class="form-label">Last Name</label>
                    <input 
                        formControlName="lastName" 
                        type="text" 
                        class="form-control h-48"
                        placeholder="Ex. Maurya" 
                        (keydown)="notAllowSpace($event)"  
                        maxlength="45"
                        (input)="validateName($event, 'lastName')"
                        (blur)="checkNameError('lastName')"
                    >
                    <div class="error-message" *ngIf="hasRequiredError('lastName')">
                        <b> &nbsp; *Required</b>
                    </div>
                    <div *ngIf="nameErrors.lastName" class="error-message alert-danger">
                      <b>Last Name cannot contain special characters (&period; &quot; &commat; &num; &dollar; and others)</b>

                    </div>
                </div>
                  <div class="col-12 mb-4">
                      <label class="form-label">Email</label>
                      <input formControlName="email_id" type="text" class="form-control h-48"
                          placeholder="Ex. xyz@gmail.com"
                          (keyup)="emailValidator($event)"
                      (keydown)="nAllowSpace($event)"
                      onkeydown="return /[a-z0-9^.+@.+\\..+$]/i.test(event.key)"
                      >
                      <!-- <div class="error-message" *ngIf="hasRequiredError('email_id')">
                          <b> &nbsp; *Required</b>
                      </div> -->
                      <div class="error-message" *ngIf="showEmailError">
                          <b> &nbsp; Email is invalid</b>
                      </div>
                  </div>
                  <div class="col-6 mb-4">
                      <label class="form-label mend">State</label>
                      <select formControlName="state"
                      [ngClass]="{ 'is-invalid': isSubmitted && f['state'].errors }"

                       class="form-select h-48" (change)="getDistrictList('true')">
                      <option value="" >Select State...</option>
                      <option *ngFor="let state of stateList" value="{{ state.name }}" >
                        {{ state.name | titlecase }}
                      </option>
                    </select>
                    <!-- <div class="error-message" *ngIf="hasRequiredError('state')">
                      <b> &nbsp; State is Required</b>
                    </div> -->
                      <div
                        *ngIf="isSubmitted && f['state'].errors && signupFormGroup.get('state').invalid && (signupFormGroup.get('state').dirty || signupFormGroup.get('state').touched || isSubmitted)"
                        class="alert-danger">
                        <div class="error-message" *ngIf="signupFormGroup.get('state').errors?.['required']">
                          <b> &nbsp; State is required</b>
                        </div>
                        <div class="error-message" *ngIf="signupFormGroup.get('state').errors?.['pattern']">
                          <b> &nbsp; State is invalid</b>
                        </div>
                      </div>
                  </div>
                  <div class="col-6 mb-4">
                      <label class="form-label mend">District</label>
                      <select formControlName="district"
                      [ngClass]="{ 'is-invalid': isSubmitted && f['district'].errors }"

                      class="form-select h-48">
                      <option value="" >Select District...</option>
                      <option *ngFor="let district of districtList" value="{{ district }}" >
                        {{ district | titlecase }}
                      </option>
                    </select>
                    <!-- <div class="error-message" *ngIf="hasRequiredError('district')">
                      <b> &nbsp; District is Required</b>
                    </div> -->
                    <div
                    *ngIf="isSubmitted && f['district'].errors && signupFormGroup.get('district').invalid && (signupFormGroup.get('district').dirty || signupFormGroup.get('district').touched || isSubmitted)"
                    class="alert-danger">
                    <div class="error-message" *ngIf="signupFormGroup.get('district').errors?.['required']">
                      <b> &nbsp; District is required</b>
                    </div>
                    <div class="error-message" *ngIf="signupFormGroup.get('district').errors?.['pattern']">
                      <b> &nbsp; District is invalid</b>
                    </div>
                  </div>
                  </div>
                
                  <!-- <div class="col-12 mb-4">
                      <div class="notification">
                          <div class="alert-n">
                              Stay updated! Get updates about your order, new vehicles, and various offers
                          </div>
                          <div class="notification-type">
                              <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="radio" name="email_and_whatsapp"
                                      id="ewnotification" formControlName="email_and_whatsapp" value="option1"
                                      checked>
                                  <label class="form-check-label" for="ewnotification">Email & WhatsApp</label>
                              </div>
                              <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="radio" formControlName="only_email"
                                      name="only_email" id="enotification" value="option2">
                                  <label class="form-check-label" for="enotification">Email only</label>
                              </div>
                          </div>
                      </div>
                  </div> -->
              </div>
              <div class="mb-2">
                  <button class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100"
                  data-toggle="tooltip" data-placement="top" title="Click here to create your account"
                  (click)="signup()">Create your account</button>
              </div>
          </div>
          <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 order-lg-2 order-1 login-banner p-0">
              <section class="banner-carousel">
                  <div id="bannerCarousel" class="bannerCarousel">
                      <ng-container *ngIf="!isLoading; else loadingContent">
                          <ngx-skeleton height="570px"></ngx-skeleton>
                      </ng-container>
                      <ng-template #loadingContent>
                          <owl-carousel-o [options]="customOptionsForBanner">
                              <ng-template carouselSlide>
                                  <a>
                                      <div class="top-banner-wrapper">
                                          <img [src]='environment1 + "assets/images/loginBanner.webp"' class="active"
                                              alt="banner_image" loading="lazy">
                                      </div>
                                  </a>
                              </ng-template>
                          </owl-carousel-o>
                      </ng-template>
                  </div>
              </section>
          </div> -->
      </div>
  </form>
</section>
